import React from "react";
import styled from "styled-components";
import { colors } from "../../Shared/colors";
import { SocialLeadsFirst } from "../../Components/SMM/SocialMediaLeads/SocialLeadsFirst";

export const SocialMediaLeadsComponent = () => {
  return (
    <Main>
      <SocialLeadsFirst />
    </Main>
  );
};

const Main = styled.div`
  background-color: ${colors.inputWhite};
  min-height: calc(100vh - 10vh);
  display: flex;
  flex-direction: column;
  align-items: center;
`;
